import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'
import Loadable from 'react-loadable'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'
import UnAuthorizedUser from 'pages/user/unAuthorizedUser'
import ApiLoader from './components/layoutComponents/ApiLoader/apiLoader'
import CommonService from './services/commonService'

const loadable = loader =>
  Loadable({
    loader,
    timeout: 1000,
    delay: false,
    loading: () => <ApiLoader />,
  })

const routes = [
  {
    path: '/dashboard',
    component: loadable(() => import('pages/dashboard/beta')),
  },
  {
    path: '/authorize/callback',
    component: loadable(() => import('pages/user/login')),
  },
  {
    path: '/unAuthorizedUser',
    component: loadable(() => import('pages/user/unAuthorizedUser')),
  },
  {
    path: '/dashboard/alpha',
    component: loadable(() => import('pages/dashboard/alpha')),
  },
  {
    path: '/comingsoon',
    component: loadable(() => import('pages/comingsoon/comingSoon')),
  },
  {
    path: '/country',
    component: loadable(() => import('pages/country/country')),
  },
  {
    path: '/managecountry',
    component: loadable(() => import('pages/country/manageCountry')),
  },
  {
    path: '/state',
    component: loadable(() => import('pages/state/state')),
  },
  {
    path: '/managestate',
    component: loadable(() => import('pages/state/manageState.js')),
  },
  {
    path: '/emailconfiguration',
    component: loadable(() => import('pages/emailConfiguration/emailConfiguration')),
  },
  {
    path: '/qualificationconfiguration',
    component: loadable(() =>
      import('pages/qualificationConfiguration/qualificationConfiguration'),
    ),
  },
  {
    path: '/managequalificationconfiguration',
    component: loadable(() =>
      import('pages/qualificationConfiguration/manageQualificationConfiguration'),
    ),
  },
  {
    path: '/rank',
    component: loadable(() => import('pages/rank/rank')),
  },
  {
    path: '/managerank',
    component: loadable(() => import('pages/rank/manageRank')),
  },
  {
    path: '/role',
    component: loadable(() => import('pages/role/role')),
  },
  {
    path: '/managerole/:Id?',
    component: loadable(() => import(`pages/role/manageRole`)),
  },
  {
    path: '/userlist',
    component: loadable(() => import('pages/user/user')),
  },
  {
    path: '/manageuser/:Id?',
    component: loadable(() => import('pages/user/manageUser')),
  },
  {
    path: '/legaldocument',
    component: loadable(() => import('pages/legalDocument/legalDocument')),
  },
  {
    path: '/manageLegalDocument',
    component: loadable(() => import('pages/legalDocument/manageLegalDocument')),
  },
  {
    path: '/itemtype',
    component: loadable(() => import('pages/itemType/itemType')),
  },
  {
    path: '/manageitemtype',
    component: loadable(() => import('pages/itemType/manageItemType')),
  },
  {
    path: '/customertype',
    component: loadable(() => import('pages/customerType/customerType')),
  },
  {
    path: '/managecustomertype',
    component: loadable(() => import('pages/customerType/manageCustomerType')),
  },
  {
    path: '/itemcategory',
    component: loadable(() => import('pages/itemCategory/itemCategory')),
  },
  {
    path: '/manageitemcategory',
    component: loadable(() => import('pages/itemCategory/manageItemCategory')),
  },
  {
    path: '/itemattributeconfiguration',
    component: loadable(() =>
      import('pages/itemAttributeConfiguration/itemAttributeConfiguration'),
    ),
  },
  {
    path: '/manageitemattributeconfiguration',
    component: loadable(() =>
      import('pages/itemAttributeConfiguration/manageItemAttributeConfiguration'),
    ),
  },
  {
    path: '/inventory',
    component: loadable(() => import('pages/inventory/inventory')),
  },
  {
    path: '/manageinventory',
    component: loadable(() => import('pages/inventory/manageInventory')),
  },
  {
    path: '/currency',
    component: loadable(() => import('pages/currency/currency')),
  },
  {
    path: '/managecurrency',
    component: loadable(() => import('pages/currency/manageCurrency')),
  },
  {
    path: '/mediacategories',
    component: loadable(() => import('pages/mediaCategories/mediaCategories')),
  },
  {
    path: '/managemediacategories/:Id?',
    component: loadable(() => import('pages/mediaCategories/manageMediaCategories')),
  },
  {
    path: '/mediapageconfiguration',
    component: loadable(() => import('pages/mediaPageConfiguration/mediaPageConfiguration')),
  },
  {
    path: '/managemediapageconfiguration/:Id?',
    component: loadable(() => import('pages/mediaPageConfiguration/manageMediaPageConfiguration')),
  },
  {
    path: '/mediapage',
    component: loadable(() => import('pages/mediaPage/mediaPage')),
  },
  {
    path: '/managemediapage',
    component: loadable(() => import('pages/mediaPage/manageMediaPage')),
  },
  {
    path: '/paymentmethod',
    component: loadable(() => import('pages/paymentMethod/paymentMethod')),
  },
  {
    path: '/managepaymentmethod',
    component: loadable(() => import('pages/paymentMethod/managePaymentMethod')),
  },
  {
    path: '/order',
    component: loadable(() => import('pages/order/order')),
  },
  {
    path: '/manageorder',
    component: loadable(() => import('pages/order/manageOrder')),
  },
  {
    path: '/commissiontype',
    component: loadable(() => import('pages/commissionType/commissionType')),
  },
  {
    path: '/managecommissiontype',
    component: loadable(() => import('pages/commissionType/manageCommissionType')),
  },
  {
    path: '/point',
    component: loadable(() => import('pages/point/point')),
  },
  {
    path: '/managepoint',
    component: loadable(() => import('pages/point/managePoint')),
  },
  {
    path: '/iwallet',
    component: loadable(() => import('pages/iWallet/iWallet')),
  },
  {
    path: '/manageiwallet',
    component: loadable(() => import('pages/iWallet/manageiWallet')),
  },
  {
    path: '/iwalletSummary',
    component: loadable(() => import('pages/reports/iWalletSummary')),
  },

  {
    path: '/iWalletWithdrawMethod',
    component: loadable(() => import('pages/reports/iWalletWithdrawMethod')),
  },
  {
    path: '/manageiWalletWithdrawMethod',
    component: loadable(() => import('pages/reports/manageiWalletWithdrawMethod')),
  },
  {
    path: '/iWallet1099Report',
    component: loadable(() => import('pages/reports/iWallet1099Report')),
  },
  {
    path: '/shippingmethod',
    component: loadable(() => import('pages/shippingMethod/shippingMethod')),
  },
  {
    path: '/manageshippingmethod',
    component: loadable(() => import('pages/shippingMethod/manageShippingMethod')),
  },
  {
    path: '/qualificationbyitem',
    component: loadable(() => import('pages/qualificationByItem/qualificationByItem')),
  },
  {
    path: '/managequalificationbyitem',
    component: loadable(() => import('pages/qualificationByItem/manageQualificationByItem')),
  },
  {
    path: '/feeconfiguration',
    component: loadable(() => import('pages/feeConfiguration/feeConfiguration')),
  },
  {
    path: '/managefeeconfiguration',
    component: loadable(() => import('pages/feeConfiguration/manageFeeConfiguration')),
  },
  {
    path: '/transactionmerchant',
    component: loadable(() => import('pages/transactionMerchant/transactionMerchant')),
  },
  {
    path: '/managetransactionmerchant',
    component: loadable(() => import('pages/transactionMerchant/manageTransactionMerchant')),
  },
  {
    path: '/ewalletconfiguration',
    component: loadable(() => import('pages/eWalletConfiguration/eWalletConfiguration')),
  },
  {
    path: '/manageewalletconfiguration',
    component: loadable(() => import('pages/eWalletConfiguration/manageeWalletConfiguration')),
  },
  {
    path: '/externalpaymentconfiguration',
    component: loadable(() =>
      import('pages/externalPaymentConfiguration/externalPaymentConfiguration'),
    ),
  },
  {
    path: '/manageexternalpaymentconfiguration',
    component: loadable(() =>
      import('pages/externalPaymentConfiguration/manageExternalPaymentConfiguration'),
    ),
  },
  {
    path: '/giftcard',
    component: loadable(() => import('pages/giftCard/giftCard')),
  },
  {
    path: '/managegiftcard',
    component: loadable(() => import('pages/giftCard/manageGiftCard')),
  },
  {
    path: '/smartshipinvoice',
    component: loadable(() => import('pages/smartShipInvoice/smartShipInvoice')),
  },
  {
    path: '/managesmartshipinvoice/:Id?',
    component: loadable(() => import('pages/smartShipInvoice/manageSmartShipInvoice')),
  },
  {
    path: '/emailtemplate',
    component: loadable(() => import('pages/emailTemplate/emailTemplate')),
  },
  {
    path: '/emailtemplateconfiguration',
    component: loadable(() => import('pages/emailTemplateConfiguration/emailTemplate')),
  },
  {
    path: '/emailtemplates',
    component: loadable(() => import('pages/emailTemplates/emailTemplates')),
  },
  {
    path: '/manageemailtemplate',
    component: loadable(() => import('pages/emailTemplate/manageEmailTemplate')),
  },
  {
    path: '/manageemailtemplateconfiguration',
    component: loadable(() => import('pages/emailTemplateConfiguration/manageEmailTemplate')),
  },
  {
    path: '/automatedEmailSetup',
    component: loadable(() => import('pages/emailTemplates/automatedEmailSetup')),
  },
  {
    path: '/manageAutomatedEmailSetup',
    component: loadable(() => import('pages/emailTemplates/manageAutomatedEmailSetup')),
  },
  {
    path: '/manageemailtemplates',
    component: loadable(() => import('pages/emailTemplates/manageEmailTemplates')),
  },
  {
    path: '/promoeventcondition',
    component: loadable(() => import('pages/promoEventCondition/promoEventCondition')),
  },
  {
    path: '/managepromoeventcondition/:Id?',
    component: loadable(() => import('pages/promoEventCondition/managePromoEventCondition')),
  },
  {
    path: '/promoaction',
    component: loadable(() => import('pages/promoAction/promoAction')),
  },
  {
    path: '/managepromoaction/:Id?',
    component: loadable(() => import('pages/promoAction/managePromoAction')),
  },
  {
    path: '/promotionconfiguration',
    component: loadable(() => import('pages/promotionConfiguration/promotionConfiguration')),
  },
  {
    path: '/managepromotionconfiguration/:Id?',
    component: loadable(() => import('pages/promotionConfiguration/managePromotionConfiguration')),
  },
  {
    path: '/customer',
    component: loadable(() => import('pages/customer/customer')),
  },
  {
    path: '/managecustomer/:Id?',
    component: loadable(() => import('pages/customer/manageCustomer')),
  },
  {
    path: '/viewcustomer/:Id?',
    component: loadable(() => import('pages/customer/viewCustomer')),
  },
  {
    path: '/binarytreeerror',
    component: loadable(() => import('pages/binaryTreeError/binaryTreeError')),
  },
  {
    path: '/pendingtoactivebonus',
    component: loadable(() => import('pages/pendingToActiveBonus/pendingToActiveBonus')),
  },
  {
    path: '/iwalletwithdrawal',
    component: loadable(() => import('pages/iWalletWithdrawal/iWalletWithdrawal')),
  },
  {
    path: '/itemingredient',
    component: loadable(() => import('pages/itemIngredient/itemIngredient')),
  },
  {
    path: '/manageitemingredient/:Id?',
    component: loadable(() => import('pages/itemIngredient/manageItemIngredient')),
  },
  {
    path: '/itemfeature',
    component: loadable(() => import('pages/itemFeature/itemFeature')),
  },
  {
    path: '/manageitemfeature/:Id?',
    component: loadable(() => import('pages/itemFeature/manageItemFeature')),
  },
  {
    path: '/language',
    component: loadable(() => import('pages/language/language')),
  },
  {
    path: '/managelanguage/:Id?',
    component: loadable(() => import('pages/language/manageLanguage')),
  },
  {
    path: '/uniLevelCommission',
    component: loadable(() => import('pages/uniLevelCommission/uniLevelCommission')),
  },
  {
    path: '/manageunilevelcommission/:Id?',
    component: loadable(() => import('pages/uniLevelCommission/manageUniLevelCommission')),
  },
  {
    path: '/influencerurl',
    component: loadable(() => import('pages/influencerRegistrationUrl/InfluencerRegistrationUrl')),
  },
  {
    path: '/manageinfluencerurl/:Id?',
    component: loadable(() =>
      import('pages/influencerRegistrationUrl/manageInfluencerRegistrationUrl'),
    ),
  },
  {
    path: '/backofficemenu',
    component: loadable(() => import('pages/backOfficeMenu/backOfficeMenu')),
  },
  {
    path: '/managebackofficemenu/:Id?',
    component: loadable(() => import('pages/backOfficeMenu/manageBackOfficeMenu')),
  },
  {
    path: '/adminmenu',
    component: loadable(() => import('pages/adminMenu/adminMenu')),
  },
  {
    path: '/manageadminmenu/:Id?',
    component: loadable(() => import('pages/adminMenu/manageAdminMenu')),
  },
  {
    path: '/smartshipARBconfiguration',
    component: loadable(() => import('pages/smartshipARBConfiguration/smartshipARBConfiguration')),
  },
  {
    path: '/restrictedsubdomain',
    component: loadable(() => import('pages/restrictedSubDomain/restrictedSubDomain')),
  },
  {
    path: '/managerestrictedsubdomain/:Id?',
    component: loadable(() => import('pages/restrictedSubDomain/manageRestrictedSubDomain')),
  },
  {
    path: '/productcredit',
    component: loadable(() => import('pages/credit/credit')),
  },
  {
    path: '/manageproductcredit',
    component: loadable(() => import('pages/credit/managecredit')),
  },
  {
    path: '/reports',
    component: loadable(() => import('pages/reports/salesReport')),
  },
  {
    path: '/commissionreports',
    component: loadable(() => import('pages/reports/commissionReport')),
  },
  {
    path: '/directCommissionConfiguration',
    component: loadable(() =>
      import('pages/directCommissionConfiguration/directCommissionConfiguration'),
    ),
  },
  {
    path: '/smartShipInvoiceProcessingLog',
    component: loadable(() =>
      import('pages/smartShipInvoiceProcessingLog/smartShipInvoiceProcessingLog'),
    ),
  },
  {
    path: '/freedomCommissionUpload',
    component: loadable(() => import('pages/leadCollectionCommission/freedomCommissionUpload')),
  },
  {
    path: '/adpCommissionUpload',
    component: loadable(() => import('pages/leadCollectionCommission/adpCommissionUpload')),
  },
  {
    path: '/freedomCommissionList',
    component: loadable(() => import('pages/leadCollectionCommission/freedomCommissionList')),
  },
  {
    path: '/adpCommissionList',
    component: loadable(() => import('pages/leadCollectionCommission/adpCommissionList')),
  },
  {
    path: '/leadCollection',
    component: loadable(() => import('pages/leadCollection/leadCollection')),
  },
  {
    path: '/dualTeamBonus',
    component: loadable(() => import('pages/dualTeamBonus/dualTeamBonus')),
  },
  {
    path: '/bonusPoolCommission',
    component: loadable(() => import('pages/bonusPoolCommission/bonusPoolCommission')),
  },
  {
    path: '/directSaleCommission',
    component: loadable(() => import('pages/directSaleCommission/directSaleCommission')),
  },
  {
    path: '/panelConfiguration',
    component: loadable(() => import('pages/panelConfiguration/panelConfiguration')),
  },
  {
    path: '/viewPanelConfiguration/:AccountID/:LocationID',
    component: loadable(() => import('pages/panelConfiguration/viewPanelConfiguration')),
  },
  {
    path: '/avantGuard',
    component: loadable(() => import('pages/avantGuard/AvantGuard')),
  },
  {
    path: '/log',
    component: loadable(() => import('pages/log/log')),
  },
  {
    path: '/health-status',
    component: loadable(() => import('pages/healthStatus/healthStatus')),
  },
  {
    path: '/cameraConfiguration',
    component: loadable(() => import('pages/cameraConfiguration/cameraConfiguration')),
  },
  {
    path: '/viewCameraConfiguration/:CameraId',
    component: loadable(() => import('pages/cameraConfiguration/viewCameraConfiguration')),
  },
]

@connect(({ user }) => ({ user }))
class Router extends React.Component {
  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
  }

  render() {
    const { history, user } = this.props
    let isUserAuthorized
    if (localStorage.getItem('IsUserAuthorized') !== null) {
      isUserAuthorized = this.CommonService.DecryptData(localStorage.getItem('IsUserAuthorized'))
    }
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/authorize/callback" />} />
            {user.authenticated && isUserAuthorized === 'false' && !user.authorized && (
              <Route component={UnAuthorizedUser} />
            )}
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                // exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
